jQuery(document).ready(function(){
	
		// Add a handler for the product description tabs
		if(jQuery('.tabs').is(":visible")) {
			
			jQuery('.tabs a').on("click", function(event){
				
				// Which tab was clicked?
				var id = jQuery(this).attr('id');
				var tab = 1;
				if(id=='tab2') {
					tab = 2;
				} else if(id=='tab3') {
					tab = 3;
				} else if(id=='tab4') {
					tab = 4;
				} else if(id=='tab5') {
					tab = 5;
				}
				
				// Is it already selected?
				var selected = false;
				var slt = jQuery(this).attr('class');
				if(slt == 'selected') {
					selected = true;
				}
				
				// If not already selected, then select the tab and show the panel
				if(!selected) {
					// deselect the current tab
					jQuery('.tabs a').removeClass('selected');
					
					// hide all the panels
					jQuery('.tab').hide();
					
					// show the selected one
					if(tab == 1) {
						jQuery('.overview').show();	
					} else if(tab == 2) {
						jQuery('.full-description').show();
					} else if(tab == 3) {
						jQuery('.ingredients').show();
					} else if(tab == 4) {
						jQuery('.delivery').show();
                    } else if(tab == 5) {
    var reviews = document.getElementById('judgeme_product_reviews');

    if (reviews) {
        reviews.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
        });
    }
}

					// select the tab that was clicked
					jQuery('.tabs #tab'+tab).addClass('selected');
				}
			});
		}
  
  		// Handler for the Contact page
		if(jQuery('.page-contact').is(":visible")) {
		ref = decodeURI(window.location.search.replace(new RegExp("^(?:.*[&\\?]" + encodeURI('ref').replace(/[\.\+\*]/g, "\\$&") + "(?:\\=([^&]*))?)?.*$", "i"), "$1"));	
          if (ref == 'guide') {
				jQuery('#message').html('Please send me your free Health and Happiness Guide.');
			}
		}
	
});